// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"33":"d18c5ff4","96":"f7a37f26","787":"8cf52469"}[chunkId] + ".chunk.js";
};